"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _plugin = _interopRequireDefault(require("@ckeditor/ckeditor5-core/src/plugin"));

var _buttonview = _interopRequireDefault(require("@ckeditor/ckeditor5-ui/src/button/buttonview"));

var _attach = _interopRequireDefault(require("./theme/icons/attach.svg"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var GrooveAddAttachment = /*#__PURE__*/function (_Plugin) {
  (0, _inherits2["default"])(GrooveAddAttachment, _Plugin);

  var _super = _createSuper(GrooveAddAttachment);

  function GrooveAddAttachment() {
    (0, _classCallCheck2["default"])(this, GrooveAddAttachment);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(GrooveAddAttachment, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      editor.ui.componentFactory.add('grooveAddAttachment', function (locale) {
        var view = new _buttonview["default"](locale);
        view.set({
          label: 'Add attachment',
          icon: _attach["default"],
          "class": 'groove-attachment-button',
          tooltip: true
        });
        view.on('execute', function () {
          var _editor$config$get = editor.config.get('grooveAddAttachmentPluginConfig'),
              openFileDialog = _editor$config$get.openFileDialog;

          openFileDialog();
        });
        return view;
      });
    }
  }]);
  return GrooveAddAttachment;
}(_plugin["default"]);

exports["default"] = GrooveAddAttachment;
//# sourceMappingURL=index.js.map